import { Divider, Grid, Paper, Tooltip } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import Modal from "../common/modal/modal";
import { connect } from "react-redux";
import LabourerDrawerForm from "./manageLabourerDrawer/labourerDrawerForm";
import { bindActionCreators } from "redux";
import { createTechnicianFailed } from "../../redux/manageLabourer/manageLabourerActions";
import { useLocalizedName } from "../../globals/langHelpers";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    labourPaper: {
        padding: 16,
        justifyContent: "center",
        width: 250,
        height: 80,
        boxShaow: "0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
        boxRadius: 4,
        margin: "16px 0px",
        cursor: "pointer",
    },
    LabourName: {
        fontSize: 18,
        lineHeight: "21px",
        fontWeight: "bold",
        color: "#111111",
        padding: "0px 4px",
    },
    LabourRole: {
        fontSize: 14,
        lineHeight: "18px",
        color: "#111111",
        margin: "10px 4px",
    },
    lastnameFirstWord: {
        fontFamily: "BellSlimBlack",
        fontSize: 32,
        fontWeight: 900,
        color: "#000000",
    },
    divider: {
        marginBottom: 5,
    },
}));
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "#FFFFFF;",
        color: "rgba(0, 0, 0, 0.87)",
        boxShadow: theme.shadows[4],
        border: "1px solid #D4D4D4",
        fontSize: 14,
    },
}))(Tooltip);

function ManageLabourersPaper(props) {
    const { getLocalizedName } = useLocalizedName();
    const classes = useStyles();
    const [sortedTechnicians, setSortedTechnicians] = React.useState([]);
    const [editFormState, setEditFormState] = React.useState({
        open: false,
        data: "",
    });

    useEffect(() => {
        setSortedTechnicians(sortTechniciansByLastName(props.technicians));
    }, [props.technicians]);

    const toggleDrawer = (open, technician) => (event) => {
        setEditFormState({ open: open, data: technician });
    };

    const sortTechniciansByLastName = (technicians) => {
        const techniciansByLastName = technicians.reduce((technicianObj, technician) => {
            const firstLetterLastName = technician.lastName.charAt(0).toLowerCase();
            if (technicianObj[firstLetterLastName]) {
                technicianObj[firstLetterLastName].push(technician);
            } else {
                technicianObj[firstLetterLastName] = [technician];
            }
            return technicianObj;
        }, {});

        const sortName = (tech) => tech.firstName + "," + tech.lastName;

        return Object.keys(techniciansByLastName)
            .map((lastNameInitial) => ({
                lastNameInitial,
                technicians: techniciansByLastName[lastNameInitial].sort((a, b) => sortName(a).localeCompare(sortName(b))),
            }))
            .sort((a, b) => a.lastNameInitial.localeCompare(b.lastNameInitial));
    };

    return (
        <>
            {sortedTechnicians.map((techGroup, i) => {
                return (
                    <div>
                        <Typography key={techGroup.lastNameInitial + i} className={classes.lastnameFirstWord}>
                            {techGroup.lastNameInitial.toUpperCase()}
                        </Typography>
                        <Divider variant="fullWidth" className={classes.divider} />
                        <Grid container spacing={2} xs={12}>
                            {techGroup.technicians.map((technician, index) => {
                                return (
                                    <Grid key={index} item>
                                        <LightTooltip title={technician.labourerName}>
                                            <Paper
                                                key={technician.labourerName + index}
                                                className={classes.labourPaper}
                                                onClick={toggleDrawer(true, technician)}>
                                                <Typography noWrap className={classes.LabourName}>
                                                    {technician.labourerName}
                                                </Typography>
                                                <Typography noWrap className={classes.LabourRole}>
                                                    {getLocalizedName({ object: technician, value: "roleJobTitle" })}
                                                </Typography>
                                            </Paper>
                                        </LightTooltip>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </div>
                );
            })}
            <LabourerDrawerForm
                state={editFormState}
                showFooter={true}
                contracts={props.contracts}
                skills={props.skills}
                {...props}
                closeform={(close) => setEditFormState({ open: close, data: "" })}
            />
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        error: state.errors,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            createTechnicianFailed,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(ManageLabourersPaper);
